import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { modalStyle } from "components/Utils/ModalStyle";
import AmenitiesService from "services/amenities.service";

export default function BookingLimitGroupCreateModal({ open, group = null, initialName = "", onClose, onCreated }) {
  const [name, setName] = useState("");
  const [futureLimit, setFutureLimit] = useState("");
  const [dailyLimit, setDailyLimit] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setName(group?.name || initialName);
      setFutureLimit(group ? String(group.max_future_bookings_per_unit) : "");
      setDailyLimit(group ? String(group.max_daily_bookings_per_user) : "");
      setError("");
    }
  }, [open, group?.id, initialName]);

  const save = async (event) => {
    event.preventDefault();
    const future = Number(futureLimit);
    const daily = Number(dailyLimit);
    if (!name.trim() || !Number.isInteger(future) || future < 1 || future > 255 ||
        !Number.isInteger(daily) || daily < 1 || daily > 255) {
      setError("Enter a group name and both limits as whole numbers between 1 and 255.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const payload = {
        name: name.trim(),
        max_future_bookings_per_unit: future,
        max_daily_bookings_per_user: daily,
      };
      const response = group?.id
        ? await AmenitiesService.updateAmenityBookingLimitGroup(group.id, payload)
        : await AmenitiesService.createAmenityBookingLimitGroup(payload);
      onCreated(response.data);
    } catch (requestError) {
      setError(requestError.response?.data?.status || "Could not create booking limit group.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={saving ? undefined : onClose}>
      <MDBox sx={modalStyle}>
        <Card sx={{ overflow: "visible" }}>
          <MDBox p={3} pb={2}><MDTypography variant="h5">{group?.id ? "Edit booking limit group" : "Add booking limit group"}</MDTypography></MDBox>
          <MDBox component="form" onSubmit={save} px={3} pb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField required fullWidth label="Group name" value={name}
                  onChange={(event) => setName(event.target.value)} />
              </Grid>
              <Grid item xs={12}>
                <TextField required fullWidth type="number" label="Maximum future bookings per unit"
                  inputProps={{ min: 1, max: 255, step: 1 }} value={futureLimit}
                  onChange={(event) => setFutureLimit(event.target.value)} />
              </Grid>
              <Grid item xs={12}>
                <TextField required fullWidth type="number" label="Maximum daily bookings per person"
                  inputProps={{ min: 1, max: 255, step: 1 }} value={dailyLimit}
                  onChange={(event) => setDailyLimit(event.target.value)} />
              </Grid>
              {error && <Grid item xs={12}><MDTypography variant="caption" color="error">{error}</MDTypography></Grid>}
              <Grid item xs={12}>
                <MDButton type="submit" color="info" disabled={saving}>{group?.id ? "Save changes" : "Save group"}</MDButton>
                <MDButton type="button" color="secondary" onClick={onClose} disabled={saving} sx={{ ml: 1 }}>Cancel</MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </Modal>
  );
}
